export default __webpack_public_path__ + "static/media/profile-cover.a322f019.jpg";